import React, { useState } from 'react'
import PropTypes from 'prop-types'

import LogoutLogo from 'src/ui/LogoutLogo/LogoutLogo'
import { PLACEMENT_TEST_LEVELS } from 'src/pages/LearningLanguageLevelAssessment/levelAssessmentData'

import LearningLanguageLevelAssessmentSkeleton from './LearningLanguageLevelAssessmentSkeleton'
import LevelAssessmentCard from './subcomponents/LevelAssessmentCard/LevelAssessmentCard'

const LearningLanguageLevelAssessment = ({
  languageCode,
  levels,
  onSubmitLevel,
  displayPlacementTest,
  currentLevel,
  isSignup,
}) => {
  const [openedElement, setOpenedElement] = useState('known')

  const handleFocusChange = (value) => {
    if (value === openedElement) {
      return
    }
    setOpenedElement(value)
  }

  return (
    <LearningLanguageLevelAssessmentSkeleton
      LogoSection={<LogoutLogo />}
      SelfAssessmentSection={
        <LevelAssessmentCard
          languageCode={languageCode}
          levelKnown
          levels={levels}
          currentLevel={currentLevel}
          open={openedElement === 'known'}
          onClick={handleFocusChange}
          onSubmitLevel={onSubmitLevel}
          isSignup={isSignup}
        />
      }
      PlacementTestSection={
        !!displayPlacementTest && (
          <LevelAssessmentCard
            isSignup={isSignup}
            languageCode={languageCode}
            levels={PLACEMENT_TEST_LEVELS}
            open={openedElement === 'unknown'}
            onClick={handleFocusChange}
          />
        )
      }
    />
  )
}

LearningLanguageLevelAssessment.propTypes = {
  languageCode: PropTypes.string,
  levels: PropTypes.array,
  onSubmitLevel: PropTypes.func.isRequired,
  displayPlacementTest: PropTypes.bool,
  currentLevel: PropTypes.object,
  isSignup: PropTypes.bool,
}

export default LearningLanguageLevelAssessment
